import { configureStore } from "@reduxjs/toolkit";
import userDataReducer from "./slice/userData";

export const store = configureStore({
  reducer: {
    userData: userDataReducer,
  },
});
